import React from "react";

export default function ComboButton({ options = [], onSelectionChange }) {
  const visible = options.length > 0 ? "visible" : "collapse";
  return (
    <div
      key={2}
      className="filter"
      style={{
        position: "initial",
        flexDirection: "row",
        visibility: visible,
      }}
    >
      <a href="#" className="icon" data-bs-toggle="dropdown">
        <i className="bi bi-three-dots"></i>
      </a>
      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
        <li className="dropdown-header text-start">
          <h6>Cambiar a:</h6>
        </li>
        {options.map((option, index) => {
          const checkState = option.checked ? `bi bi-check2` : "";
          return (
            <>
              <li
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  padding: "0px 10px",
                }}
              >
                <i className={`${checkState}`}></i>
                <a
                  className="dropdown-item"
                  onClick={() => onSelectionChange(option)}
                >
                  {option.name}
                </a>
              </li>
            </>
          );
        })}
      </ul>
    </div>
  );
}
